module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_4.ca11d10d.png";